<script>
export default {
  name: "InnerRadio",
  functional: true,
  render: function (h, { props, parent, children, listeners, ...args }) {
    const { name, enumValues, value, disabled = false, showLabel } = props;
    const change = listeners.change;
    return (
      <div class={'inner_radio_div'}>
        {name && showLabel && <span class="scence_ctr_span_title radio_title">{name}</span>}
        <div class="radio">
          {enumValues.map(el =>
            <el-radio onChange={() => change(el.Value)} disabled={!!disabled} value={value} label={el.Value} key={el.Value}>{el.Name}</el-radio>
          )}
        </div>
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "~@/components/button/comps-button.scss";

.radio {
  margin-left: 0px !important;
  width: auto;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  margin-top: 3px;
}

.inner_radio_div {
  margin-top: 10px;
}


</style>
